import { render, staticRenderFns } from "./VoiceRecognition.vue?vue&type=template&id=0d808134&scoped=true"
import script from "./VoiceRecognition.vue?vue&type=script&lang=js"
export * from "./VoiceRecognition.vue?vue&type=script&lang=js"
import style0 from "./VoiceRecognition.vue?vue&type=style&index=0&id=0d808134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d808134",
  null
  
)

export default component.exports